import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import '@/style/common.scss'
import defaultSettings from '@/settings'
import './utils/rem'
import './utils/permission.js'
// import axios from 'axios'

// axios({
//   url: '/jy-mobile-vod-he-ui/config.json',
//   // url: '/config.json',
//   method: 'get'
// }).then(res => {
//   document.title = res.data['APPLICATION_TITLE']
// })// 修改项目title
// options 为可选参数，无则不传

if (process.env.NODE_ENV === 'development' && defaultSettings.vconsole) {
  const VConsole = require('vconsole')
  // eslint-disable-next-line
  const my_console = new VConsole()
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
